import React from 'react';
import { ListPathQuestionSchemaType } from '../../../generated/types.js';
import { __rest } from '../../../_virtual/_tslib.js';
import DropDown from './DropDown/index.js';
import SelectList$1 from './SelectList/index.js';
import SelectList from './PillList/index.js';

var ListQuestion = function ListQuestion(_a) {
  var question = _a.question,
      rest = __rest(_a, ["question"]);

  var listQuestion = question;

  switch (listQuestion.listSchemaType) {
    case ListPathQuestionSchemaType.DROP_DOWN:
      return React.createElement(DropDown, Object.assign({
        question: question
      }, rest));

    case ListPathQuestionSchemaType.MULTI_SELECT_LIST:
    case ListPathQuestionSchemaType.SINGLE_SELECT_LIST:
      return React.createElement(SelectList$1, Object.assign({
        question: question
      }, rest));

    case ListPathQuestionSchemaType.MULTI_SELECT_PILLS:
      return React.createElement(SelectList, Object.assign({
        question: question
      }, rest));

    default:
      throw new Error("Unhandled ListPathQuestionSchemaType of [".concat(listQuestion.listSchemaType, "]"));
  }
};

export default ListQuestion;
//# sourceMappingURL=index.js.map
